import styled from 'styled-components';

import media from '../../../../theme/media';

export const Container = styled.div`
    padding: 72px 24px 92px 24px;
    max-width: 480px;
    margin: 0 auto;
    min-height: calc(100vh - 164px);
    position: relative;
    display: flex;
    flex-direction: column;

    ${media.tablet720} {
        padding: 128px 144px 152px 144px;
        max-width: 100%;
        min-height: calc(100vh - 280px);
    }

    ${media.tablet1080} {
        max-width: 792px;
    }

    ${media.desktop1224} {
        padding-left: 144px;
        padding-right: 144px;
        margin: 0;
    }
`;

export const BlockSubheader = styled.div`
    color: ${(props) => props.theme.grey_72_lc};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 16px 0;

    ${media.tablet720} {
        padding: 24px 0;
    }

    ${media.tablet937} {
        width: 216px;
        flex-shrink: 0;
    }

    ${media.desktop1920} {
        font-size: 17px;
        line-height: 24px;
    }
`;

export const IntroBlock = styled.div`
    text-align: center;
    margin-bottom: 32px;

    ${media.tablet720} {
        margin-bottom: 48px;
    }
`;
export const IntroBlockImg = styled.figure`
    width: 240px;
    margin: 0 auto 24px;

    ${media.tablet720} {
        margin-bottom: 32px;
        width: 360px;
    }

    img {
        max-width: 100%;
        width: 100%;
    }
`;

export const FeaturesBlock = styled.div`
    display: flex;
    flex-direction: column;

    ${media.tablet937} {
        flex-direction: row;
    }

    ${media.desktop1224} {
        flex-direction: column;
    }

    ${media.desktop1296} {
        flex-direction: row;
    }
`;

export const FeaturesList = styled.ul`
    font-size: 17px;
    line-height: 24px;
    margin-top: 24px;

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }
`;
export const FeaturesListItem = styled.li`
    display: flex;
    align-items: center;
    margin-bottom: 32px;
`;
